import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import en from './locales/en/translation.json';
import de from './locales/de/translation.json';

const SUPPORTED_LANGUAGES = ['en', 'de'];
const DEFAULT_LANGUAGE = 'en';

const DEFAULT_PHONE_COUNTRY_BY_LANGUAGE = {
    en: 'US',
    de: 'DE'
};

const getDefaultPhoneCountry = lang => (
    DEFAULT_PHONE_COUNTRY_BY_LANGUAGE[lang] || DEFAULT_PHONE_COUNTRY_BY_LANGUAGE[DEFAULT_LANGUAGE]
);

i18n.on('languageChanged', lang => {
    dayjs.locale(lang);
});

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            de: { translation: de }
        },
        lng: DEFAULT_LANGUAGE,
        fallbackLng: DEFAULT_LANGUAGE,
        interpolation: { escapeValue: false },
        returnEmptyString: false
    });

export {
    i18n,
    SUPPORTED_LANGUAGES,
    DEFAULT_LANGUAGE,
    getDefaultPhoneCountry
};
